export default __webpack_public_path__ + "static/media/lisieux16.757dcece.jpg";